"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Percent = void 0;
const jsbi_1 = __importDefault(require("jsbi"));
const fraction_1 = require("./fraction");
const ONE_HUNDRED = new fraction_1.Fraction(jsbi_1.default.BigInt(100));
/**
 * Converts a fraction to a percent
 * @param fraction the fraction to convert
 */
function toPercent(fraction) {
    return new Percent(fraction.numerator, fraction.denominator);
}
class Percent extends fraction_1.Fraction {
    constructor() {
        super(...arguments);
        /**
         * This boolean prevents a fraction from being interpreted as a Percent
         */
        this.isPercent = true;
    }
    /**
     * Parses a {@link Percent} from a float.
     * @param number Number to parse. (100% is 1.00)
     * @param decimals Number of decimals of precision. (default 10)
     * @returns Percent
     */
    static fromNumber(number, decimals = 10) {
        const frac = fraction_1.Fraction.fromNumber(number, decimals);
        return new Percent(frac.numerator, frac.denominator);
    }
    /**
     * Parses a {@link Percent} from a given number of bps.
     * @returns Percent
     */
    static fromBPS(bps) {
        return new Percent(bps, 10000);
    }
    add(other) {
        return toPercent(super.add(other));
    }
    subtract(other) {
        return toPercent(super.subtract(other));
    }
    multiply(other) {
        return toPercent(super.multiply(other));
    }
    divide(other) {
        return toPercent(super.divide(other));
    }
    toSignificant(significantDigits = 5, format, rounding) {
        return super
            .multiply(ONE_HUNDRED)
            .toSignificant(significantDigits, format, rounding);
    }
    toFixed(decimalPlaces = 2, format, rounding) {
        return super.multiply(ONE_HUNDRED).toFixed(decimalPlaces, format, rounding);
    }
    /**
     * Returns true if the other object is a {@link Percent}.
     *
     * @param other
     * @returns
     */
    static isPercent(other) {
        var _a;
        return (fraction_1.Fraction.isFraction(other) &&
            ((_a = other) === null || _a === void 0 ? void 0 : _a.isPercent) === true);
    }
}
exports.Percent = Percent;
Percent.ZERO = new Percent(0);
/**
 * 1%
 */
Percent.ONE = new Percent(1, 100);
/**
 * 100% (1/1)
 */
Percent.ONE_HUNDRED = new Percent(1);
//# sourceMappingURL=percent.js.map